<template>
  <div>
    <div class="app-toolbar1">
      <el-input size="small" placeholder="请输入关键字" v-model="query.keyword" clearable style="width:320px">
        <el-button slot="append" size="small" icon="el-icon-search" @click="load(1)">查询</el-button>
      </el-input>
      <el-button size="small" icon="el-icon-plus" @click="toAdd" type="primary">新建</el-button>
    </div>
    <el-table :data="pages" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="pageId" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="status" label="状态" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 'ENABLE'">已发布</span>
          <span v-else>未发布</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="135"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" width="135"></el-table-column>
      <el-table-column fixed="right" label="操作" width="330">
        <template slot-scope="scope">
          <el-button @click="toClone(scope.row.pageId)" type="primary" size="small">克隆新建</el-button>
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">配置</el-button>
          <el-button @click="changeStatus(scope.row)" type="danger" size="small" v-if="scope.row.status === 'ENABLE'">撤销发布</el-button>
          <el-button @click="changeStatus(scope.row)" type="danger" size="small" v-if="scope.row.status === 'DISABLE'">发布</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <page-config-dialog :endpoint="endpoint" :uiId="uiId" ref="configDialog" @save="load(query.page)"></page-config-dialog>
  </div>
</template>

<script>
import { calcPage } from '../../util'
import PageConfigDialog from './PageConfigDialog'

export default {
  name: 'page-manage',
  components: {
    PageConfigDialog
  },
  props: {
    uiId: { type: Number, required: true },
    endpoint: { type: String, required: true }
  },
  data () {
    return {
      loading: false,
      pages: [],
      query: {
        page: 1,
        limit: 10,
        total: 0,
        keyword: ''
      }
    }
  },
  created () {
    this.load(1)
  },
  watch: {
    uiId () {
      this.load(1)
    }
  },
  methods: {
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgPages?uiId=${this.uiId}&page=${page}&limit=${this.query.limit}&keyword=${this.query.keyword}`
      }).then((res) => {
        let pageData = res.data.data
        this.pages = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAdd () {
      this.$refs.configDialog.open()
    },
    toUpdate (row) {
      this.$refs.configDialog.open(row)
    },
    toClone (pageId) {
      this.$refs.configDialog.open({pageId: pageId, clone: true})
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该页面吗?', data: row, scope: this, callback: this.doDelete })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgPages/${data.pageId}`
        }).then((rsp) => {
          if (rsp.data.status !== 'yes') {
            this.$message.warning(`删除失败：${rsp.data.message}`)
            return
          }
          this.$message.success('删除成功')
          this.load(calcPage(this.query))
        })
      }
    },
    changeStatus (row) {
      this.$http.request({
        method: 'put',
        url: `/api/cgPages/${row.pageId}/status`,
        data: JSON.stringify({
          status: row.status === 'ENABLE' ? 'DISABLE' : 'ENABLE'
        })
      }).then(() => {
        this.load(this.query.page)
      })
    }
  }
}
</script>
